<div class="layout-row around-center layout-wrap">
  @if (showAvatar) {
    <div class="avatar flex-0">
      <img alt="user" fsAvatar [size]="dense ? 24 : avatarSize" [profileId]="userId || null"/>
    </div>
  }
  <div class="flex-1" [ngClass]="{'user-infos': showAvatar}">
    @if (!dense) {
      @if (username) {
        <span class="title">{{username}}</span>
      }
      <span class="subtitle">{{email}}</span>
    } @else {
      <span class="dense-title">{{username || email}}</span>
    }
  </div>
  @if (showRoles) {
  <div class="user-role">
    <mat-chip-listbox selectable="false" ariaOrientation="horizontal">
      @for (role of roles; track role) {
        <mat-chip-option>{{role}}</mat-chip-option>
      }
    </mat-chip-listbox>
  </div>
  }
</div>
